import { Button, DialogBody, Image, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { ModalPaywallVariantProps, SharedModalProps } from 'types/Modal';
import paywallImage from 'assets/subscription/paywall.png';
import { CustomModal } from '../CustomModal';

type Props = SharedModalProps & ModalPaywallVariantProps;

export const PaywallModal = ({
  handleClose,
  isShown,
  target,
  onUpgradeClick,
}: Props): ReactElement => {
  return (
    <CustomModal
      isOpen={isShown}
      onClose={handleClose}
      hideHeader
      placement="center"
      target={target}
      size="lg"
    >
      <DialogBody
        display="flex"
        gap="25px"
        flexDirection="column"
        alignItems="center"
        p="40px 30px"
      >
        <Image src={paywallImage} maxWidth="400px" />
        <Text textStyle="h2.medium">Du brauchst Premium, um diesen Inhalt zu sehen!</Text>
        <Text textStyle="body.m.regular">
          Leider ist Dein Abonnement ausgelaufen. Bitte wähle ein für Dich passendes Abonnement und
          viel Spaß beim Lernen!
        </Text>
        <Button variant="primary" onClick={onUpgradeClick}>
          Upgrade auf Premium
        </Button>
      </DialogBody>
    </CustomModal>
  );
};
